import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[intDigits]',
})
export class IntDigitsDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^[0-9]+$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-'];

  @Input('decimalDigits') decimalDigits: number;

  constructor(private el: ElementRef) {
    //this.regex = new RegExp(/^\d*\.?\d{0,2}$/g);
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log(this.el.nativeElement.value);
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
